import { useEffect, useState } from 'react';

export default function useDebouncedState<T>(state: T, debounceTime = 0): T {
  const [newState, setNewState] = useState<T>(state);

  useEffect(() => {
    if (JSON.stringify(state) !== JSON.stringify(newState)) {
      const timerId = setTimeout(() => setNewState(state), debounceTime);
      return () => clearTimeout(timerId);
    }
  }, [state]); // eslint-disable-line react-hooks/exhaustive-deps

  return newState;
}
